module.exports = __webpack_public_path__ + "static/media/github-profile.5afdce41.gif";